import * as React from 'react';
import { useState, useEffect, Children } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { WithPermissions, useCheckAuth, LogoutOnMount } from '../auth';
import { useScrollToTop, useCreatePath } from '../routing';
import { useConfigureAdminRouterFromChildren } from './useConfigureAdminRouterFromChildren';
export var CoreAdminRoutes = function (props) {
    useScrollToTop();
    var createPath = useCreatePath();
    var _a = useConfigureAdminRouterFromChildren(props.children), customRoutesWithLayout = _a.customRoutesWithLayout, customRoutesWithoutLayout = _a.customRoutesWithoutLayout, status = _a.status, resources = _a.resources;
    var Layout = props.layout, CatchAll = props.catchAll, dashboard = props.dashboard, LoadingPage = props.loading, menu = props.menu, requireAuth = props.requireAuth, Ready = props.ready, title = props.title;
    var _b = useState(requireAuth), onlyAnonymousRoutes = _b[0], setOnlyAnonymousRoutes = _b[1];
    var _c = useState(requireAuth), checkAuthLoading = _c[0], setCheckAuthLoading = _c[1];
    var checkAuth = useCheckAuth();
    useEffect(function () {
        if (requireAuth) {
            // do not log the user out on failure to allow access to custom routes with no layout
            // for other routes, the LogoutOnMount component will log the user out
            checkAuth(undefined, false)
                .then(function () {
                setOnlyAnonymousRoutes(false);
            })
                .catch(function () { })
                .finally(function () {
                setCheckAuthLoading(false);
            });
        }
    }, [checkAuth, requireAuth]);
    if (status === 'empty') {
        return React.createElement(Ready, null);
    }
    // Note: custom routes with no layout are always rendered, regardless of the auth status
    if (status === 'loading' || checkAuthLoading) {
        return (React.createElement(Routes, null,
            customRoutesWithoutLayout,
            React.createElement(Route, { path: "*", element: React.createElement("div", { style: { height: '100vh' } },
                    React.createElement(LoadingPage, null)) })));
    }
    if (onlyAnonymousRoutes) {
        return (React.createElement(Routes, null,
            customRoutesWithoutLayout,
            React.createElement(Route, { path: "*", element: React.createElement(LogoutOnMount, null) })));
    }
    return (React.createElement(Routes, null,
        customRoutesWithoutLayout,
        React.createElement(Route, { path: "/*", element: React.createElement("div", null,
                React.createElement(Layout, { dashboard: dashboard, menu: menu, title: title },
                    React.createElement(Routes, null,
                        customRoutesWithLayout,
                        Children.map(resources, function (resource) { return (React.createElement(Route, { key: resource.props.name, path: "".concat(resource.props.name, "/*"), element: resource })); }),
                        React.createElement(Route, { path: "/", element: dashboard ? (React.createElement(WithPermissions, { authParams: defaultAuthParams, component: dashboard })) : resources.length > 0 ? (React.createElement(Navigate, { to: createPath({
                                    resource: resources[0].props.name,
                                    type: 'list',
                                }) })) : null }),
                        React.createElement(Route, { path: "*", element: React.createElement(CatchAll, { title: title }) })))) })));
};
var defaultAuthParams = { params: { route: 'dashboard' } };
//# sourceMappingURL=CoreAdminRoutes.js.map